import { render, staticRenderFns } from "./MaterialViewer.vue?vue&type=template&id=67db9d23"
import script from "./MaterialViewer.vue?vue&type=script&lang=js"
export * from "./MaterialViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports